module.exports = __webpack_public_path__ + "static/media/philosophieimage.cb0e6f15.jpg";